import { useCallback, useId } from 'react';
import classnames from 'classnames';
import { debounce, prettyMoney } from '@/helpers/utils';
import { MoneyInput } from '../MoneyInput';
import { RangeInput } from '../RangeInput';
import s from './index.module.scss';

export const RangeField = ({
  label,
  min,
  max,
  value,
  step,
  onRangeChange,
  onInputChange,
}) => {
  const id = useId();
  const handleInput = value => {
    const money = Number(value) || 0;
    handleDebounceChange(money);
  };

  const handleDebounceChange = useCallback(
    debounce(money => {
      if (money > max) {
        return onInputChange(max);
      }
      if (money < min) {
        return onInputChange(min);
      }
      onInputChange(money);
    }, 500),
    []
  );

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className={classnames(s.label, 'f-body-accent')}>{label}</div>
        <MoneyInput
          id={id}
          value={value}
          onChange={handleInput}
          className={s.input}
        />
      </div>
      <RangeInput
        value={[value]}
        step={step}
        min={min}
        max={max}
        onChange={onRangeChange}
        className={s.range}
      />
      <div className={s.range_footer}>
        <div className="f-small-regular">{prettyMoney(min)}</div>
        <div className="f-small-regular">{prettyMoney(max)}</div>
      </div>
    </div>
  );
};
